"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Input = _interopRequireDefault(require("./Input"));
var _icon = require("../icon");
var _button = _interopRequireDefault(require("../button"));
var _configProvider = require("../config-provider/configProvider");
var _utils = require("../utils");
var _excluded = ["className", "size", "enterButton", "loading", "onSearch", "onChange", "onPressEnter", "value", "style"];
/* istanbul ignore file */
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var Search = function Search(props) {
  var _useContext = (0, _react.useContext)(_configProvider.ConfigContext),
    getPrefixCls = _useContext.getPrefixCls;
  var PREFIX = getPrefixCls('input-search');
  var className = props.className,
    size = props.size,
    enterButton = props.enterButton,
    loading = props.loading,
    onSearch = props.onSearch,
    onChange = props.onChange,
    onPressEnter = props.onPressEnter,
    propsValue = props.value,
    style = props.style,
    restProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  var _useState = (0, _react.useState)(propsValue),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    value = _useState2[0],
    setValue = _useState2[1];
  (0, _react.useEffect)(function () {
    setValue(propsValue);
  }, [propsValue]);
  var handleSearch = function handleSearch() {
    if (onSearch && !loading) {
      onSearch(String(value));
    }
  };
  var handleChange = function handleChange(e) {
    if (!('value' in props)) {
      setValue(e.target.value);
    }
    onChange === null || onChange === void 0 || onChange(e);
  };
  var handlePressEnter = function handlePressEnter(e) {
    onPressEnter === null || onPressEnter === void 0 || onPressEnter(e);
    handleSearch();
  };
  var btn = null;
  if ((0, _utils.isString)(enterButton)) {
    btn = /*#__PURE__*/_react.default.createElement(_button.default, {
      type: "primary",
      loading: loading,
      size: size,
      onClick: handleSearch
    }, enterButton);
  } else if ((0, _utils.isBoolean)(enterButton)) {
    btn = /*#__PURE__*/_react.default.createElement(_button.default, {
      type: "primary",
      loading: loading,
      size: size,
      icon: "search",
      onClick: handleSearch
    });
  } else if ((0, _utils.isFunction)(enterButton)) {
    btn = /*#__PURE__*/_react.default.cloneElement(enterButton(loading), {
      onClick: handleSearch
    });
  }
  // 当用户使用Input自带的icon时
  var suffixIcon = null;
  if (!enterButton) {
    suffixIcon = loading ? /*#__PURE__*/_react.default.createElement(_icon.Icon, {
      type: "loading"
    }) : /*#__PURE__*/_react.default.createElement(_icon.Icon, {
      type: "search",
      onClick: handleSearch
    });
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)("".concat(PREFIX), className, (0, _defineProperty2.default)({}, "".concat(PREFIX, "-with-button"), !!enterButton)),
    style: style
  }, /*#__PURE__*/_react.default.createElement(_Input.default, _objectSpread(_objectSpread({}, restProps), {}, {
    // 必须这样写，否则受控模式下，无法输入中文
    value: 'value' in props ? propsValue : value,
    size: size,
    type: "text",
    clearable: false,
    suffix: suffixIcon,
    onChange: handleChange,
    onPressEnter: handlePressEnter
  })), enterButton ? btn : null);
};
Search.displayName = 'Search';
var _default = exports.default = Search;